import React from "react";
import GlobalStyles from 'styles/GlobalStyles';
import LandingPage from "LandingPage.js";
import DocumentsPage from "pages/Documents.js";
import MembersPage from "pages/UserManagement.js";
import FinancePage from "pages/Finance.js";
import InvoicesPage from "pages/Invoices.js";
import ProfilePage from "pages/Profile.js";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import useAuth from 'hooks/useAuth';
import AuthContext from 'contexts/AuthContext';

const ErrorPage = () => {
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred. Please try reloading the page.</p>
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/documents',
    element: <DocumentsPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/finance',
    element: <FinancePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/invoices',
    element: <InvoicesPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/members',
    element: <MembersPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
    errorElement: <ErrorPage />,
  },
]);

export default function App() {
  const {role, designation, user, setUser, logout} = useAuth();

  return (
    <AuthContext.Provider value={{role, designation, user, setUser, logout}}>
      <GlobalStyles />
      <RouterProvider router={router} />
    </AuthContext.Provider>
  );
}
